/**
 * @param {Object} params
 * @param {String} params.provider
 * @param {Number} params.id
 * @returns {Promise<{assets: *}>}
 */

export default async function getRelatedAssets({ provider, id }) {
    return this.get(`/${provider}/${id}`);
}
